export default __webpack_public_path__ + "static/media/passLogo.59f355e6.svg";